module.exports = __webpack_public_path__ + "img/rights_microphone.332335f7.png";